/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePng = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M20.513 11.887c.211 0 .42.019.628.055.21.037.409.092.592.165v.912a4.218 4.218 0 0 0-.628-.152 3.196 3.196 0 0 0-.551-.049c-.53 0-.937.14-1.222.421-.28.276-.42.675-.42 1.195 0 .579.122 1.014.365 1.303.249.285.626.428 1.132.428.193 0 .382-.011.566-.034l.069-.012v-.97l-.849-.28v-.58h1.856v2.463a3.636 3.636 0 0 1-1.076.304 4.197 4.197 0 0 1-.594.04c-.846 0-1.488-.225-1.925-.676-.432-.45-.648-1.113-.648-1.986 0-.539.105-.996.317-1.374.216-.381.525-.672.925-.87.404-.202.892-.303 1.463-.303zm-10.267.096c.616 0 1.08.143 1.394.428.317.285.476.709.476 1.27 0 .372-.071.685-.214.938a1.327 1.327 0 0 1-.628.566c-.276.13-.619.194-1.028.194h-.725V17H8.452v-5.017zm-.725 2.519h.504c.368 0 .628-.062.78-.187.156-.128.235-.34.235-.634 0-.3-.079-.511-.235-.635-.152-.124-.412-.186-.78-.186h-.504zm6.417.747v-3.266h1.063V17h-.994l-2.166-3.269V17h-1.063v-5.017h.993z" />
      </g>
    </g>
  </Icon>
);
export { SvgFilePng as FilePng };
